var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.privileged && Object.keys(_vm.currentCampaign.info).length
    ? _c("div", { staticClass: "campaign-details" }, [
        _c(
          "div",
          { staticClass: "vs-container--settings-small" },
          [
            _vm.campaignEnded
              ? _c("vs-alert", {
                  staticClass: "vs-alert--campaign",
                  attrs: {
                    "no-gutter": "no-gutter",
                    message: "!--- Editing is Disabled ---!"
                  }
                })
              : _vm._e(),
            _c(
              "vs-container",
              {
                attrs: {
                  "hide-search": "hide-search",
                  "hide-date": "hide-date",
                  title: "Details",
                  "button-icon": "content-save",
                  "button-text": "save",
                  tabs: _vm.tabs,
                  "active-tab": _vm.activeTab,
                  processing: _vm.processing,
                  "button-not-visible": _vm.campaignEnded,
                  "button-disabled": _vm.campaignEnded || _vm.processing
                },
                on: {
                  "container-button-click": _vm.save,
                  "change-tab": _vm.handleChangeTab
                }
              },
              [
                _c("router-view", { on: { "save-campaign-details": _vm.save } })
              ],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }